export default {
    MONEY: 1,
    PERCENTAGE: 2,
};
